export default __webpack_public_path__ + "static/char-52-anr-cbb4696d42c15e50f1d3f465606f36cd.gif";